import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import CreateModal from '../component/CreateModal';
import UpdateModal from '../component/UpdateModal';
import * as actions from '../../../action';
import * as c from '../../../constant';
import { ucwords } from '../../../../../applications/helper';

function BusinessActivitiesContainer({
  // getNewBusinessActivitiesList,
  // newBusinessActivitiesList,
  getSingleNewBusinesses,
  newBusinessesInfo,
  newBusinessesId,
  removeNewBusinessActivities,
  // toggleRetirement,
  toggleActivityRetirement,
  toggleActivityRetirementLoading,

  setIsRetired,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleAddBusinessActivities = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal newBusinessesId={newBusinessesId} />,
      title: 'Add Business Activities',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBusinessActivities = (id, data) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.attributes}
          id={id}
          businessActivitiesId={data.id}
          businessActivitiesInfo={data}
        />
      ),
      title: 'Update Business Activities',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveBusinessActivities = (id, data) => e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business activity?',
      () => {
        removeNewBusinessActivities(id, data.id, () => {
          getSingleNewBusinesses(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleActivityRetirement = (id, isRetiredUpdatedValue) => {
    const transactionId = _.get(newBusinessesInfo, "id")

    ConfirmAlert(
      `Are you sure you want to ${isRetiredUpdatedValue === 0 ? 'retire' : 'unretire'} this business activity?`,
      () => toggleActivityRetirement(transactionId, id, {}, () => setIsRetired(isRetiredUpdatedValue)),
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  }

  const businessActivityItem = (item, details, businessRetireStatus) => {
    return (
      <div key={item.id} className="card-body">
        <div className="border rounded p-3 mb-3">
          <table className="transaction-table table table-borderless table-sm">
            <tbody>
              <tr>
                <td className="text-dark" width="250">
                  Name
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{_.get(item, 'attributes.name')}</b>
                </td>
                <td className="text-right">
                  {_.get(item, 'attributes.is_retired') === 0 &&
                    Acl(permissions, ['EDIT BUSINESS ACTIVITY']) && (
                      <button
                        onClick={handleUpdateBusinessActivities(
                          newBusinessesId,
                          item
                        )}
                        type="button"
                        className="btn-blank mb-2"
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    )}
                  {_.get(item, 'attributes.is_retired') === 0 &&
                    Acl(permissions, ['DELETE BUSINESS ACTIVITY']) && (
                      <button
                        type="button"
                        className="btn-blank mb-2"
                        onClick={handleRemoveBusinessActivities(
                          newBusinessesId,
                          item
                        )}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    )}
                  {
                    businessRetireStatus === 0 &&
                    Acl(permissions, ['BPLS BUSINESS ACTIVITY RETIRE']) && (
                      <button
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  ml-1" 
                        type="button"
                        style={{ width: "91px" }}
                        onClick={() => handleActivityRetirement(item.id, _.get(item, "attributes.is_retired"))}
                      >
                        {_.get(item, "attributes.is_retired") === 1 ? "Unretire" : "Retire"} {toggleActivityRetirementLoading ? <i className="fa fa-spin fa-spinner" /> : ""}
                      </button>
                  )}
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="250">
                  Status
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {_.get(item, 'attributes.is_validated')
                      ? 'Validated'
                      : 'For Validation'}
                  </b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="250">
                  Capital Amount
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{_.get(item, 'attributes.capital_amount_human')}</b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="250">
                  Gross Amount
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{_.get(item, 'attributes.gross_amount_human')}</b>
                </td>
              </tr>
              {Object.entries(details).map(detailsList => {
                return (
                  <tr key={detailsList.id}>
                    <td className="text-dark" width="250">
                      {ucwords(detailsList[0].replace(/_/g, ' ')) || '-'}
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {ucwords(
                          detailsList[1].toString().replace(/_/g, ' ')
                        ) || '-'}
                      </b>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // const retiredBusinessFilter = (data, is_retired) => {
  //   return data.filter(item => item.attributes.is_retired === is_retired)
  // }
  return (
    <div className="row my-3 mx-2 justify-content-center">
      <div className="col-12 d-flex justify-content-end">
        {Acl(permissions, ['ADD BUSINESS ACTIVITY']) && 
        _.get(newBusinessesInfo, 'attributes.is_retired') === 0 &&
        (
          <button
            onClick={handleAddBusinessActivities}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2"
          >
            Add Business Activity
          </button>
        )}
      </div>
      <div className="col-12">
        <p>Active Businesses</p>
        {_.get(newBusinessesInfo, 'included.activities').length !== 0 ? (
          _.get(newBusinessesInfo, 'included.activities').map(item => {
            const details = _.get(item, 'attributes.details') || {};
            return businessActivityItem(item, details, _.get(newBusinessesInfo, 'attributes.is_retired'));
          })
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
      <div className="col-12">
        <p>Retired Businesses</p>
        {_.get(newBusinessesInfo, 'included.retiredActivities').length !== 0 ? (
          _.get(newBusinessesInfo, 'included.retiredActivities').map(item => {
            const details = _.get(item, 'attributes.details') || {};
            return businessActivityItem(item, details, _.get(newBusinessesInfo, 'attributes.is_retired'));
          })
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BusinessActivitiesContainer.defaultProps = {
  setIsRetired: () => {},
}

BusinessActivitiesContainer.propTypes = {
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  // newBusinessActivitiesList: PropTypes.instanceOf(Array).isRequired,
  newBusinessesInfo: PropTypes.instanceOf(Object).isRequired,
  newBusinessesId: PropTypes.string.isRequired,
  removeNewBusinessActivities: PropTypes.instanceOf(Function).isRequired,
  // toggleRetirement: PropTypes.instanceOf(Function).isRequired,
  toggleActivityRetirement: PropTypes.instanceOf(Function).isRequired,
  setIsRetired: PropTypes.instanceOf(Function),
  toggleActivityRetirementLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({api}) => ({
  toggleActivityRetirementLoading: api.loading.indexOf(c.TOGGLE_ACTIVITY_RETIREMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivitiesContainer);
